var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 755.925,
    height: 800.102,
    viewBox: "0 0 755.925 800.102",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-664.763 -175.589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.9,316.348c-2.839,11.375.958,22.047,8.48,23.838s15.918-5.978,18.755-17.357a28.294,28.294,0,0,0,.157-13.848l11.395-48.341L357,255.81l-8.719,48.173a28.7,28.7,0,0,0-6.385,12.373Z",
    transform: "translate(748.574 315.456)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1102.311 908.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.583,566.9l-1.459,31.687,1.462,8.768-5.115,10.229-40.187,4.384-2.193-18.991,21.19-10.96.616-17.9Z",
    transform: "translate(-245.123 -566.9)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.422,612.228l2.193,2.922L372.7,603.022s-1.9,18.7-1.9,22.358-69.413,3.653-79.858,2.193-7.091-10.96-7.091-10.96l43.316-20.5,1.255,16.114Z",
    transform: "translate(-283.339 -564.471)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1228.785 884.921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.935,545.365l8.758,30.487,4.191,7.834-1.573,11.329-36.669,17.014-8.156-17.3,16.567-17.16-10.392-26.949Z",
    transform: "translate(-144.25 -545.365)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.249,601.417l3.013,2.068,35.991-24.959s4.187,18.328,5.356,21.79-64.6,25.676-74.958,27.634-10.225-8.114-10.225-8.114L204.9,586.546Z",
    transform: "translate(-170.426 -542.606)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.7,84.393l-1.535,24.92,46.533,2.361-14.41-32.833Z",
    transform: "translate(939.234 300.725)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.631,103.531c12.472,5.564,32.422,4.041,55.03,0L331.2,260.165s-70.722,14.219-95.038-12.016l12.8-127.978,23.676-16.638h0Z",
    transform: "translate(911.586 302.779)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.547,240.579l99.848,9.868L350.66,585H312.908L248.26,355.76l-5.119,259.8H208.585L179.15,297.53Z",
    transform: "translate(953.874 314.187)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.379,94.672l33.546,19.855A32.3,32.3,0,0,1,277.473,151.4l-25.926,88.551s42.218,72.531,28.5,78.929c-30.828,14.379-76.828,10.878-76.828,10.878L213.5,156.1,229.38,94.669h0Z",
    transform: "translate(995.673 302.042)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.855,102.924,322.925,117.66l-8.959,109.422-25.089,88.15c42.493,15.511,38.525,8.283,38.525,8.283l7.038-152.1,26.414-68.484h0Z",
    transform: "translate(824.818 302.73)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,312.516l.13-.6L376.4,132.586a15.418,15.418,0,1,0-30.053-6.906L303.76,300.738,337.5,312.514Z",
    transform: "translate(792.766 303.58)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.752,
    cy: 37.752,
    rx: 37.752,
    ry: 37.752,
    transform: "translate(1169.378 316.234)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,10.913c-8.316,2.922-13.074,4.6-17.433,8.794-7.362,7.093-8.578,16.571-9.706,25.379-.883,6.89-2.026,15.8,2.014,25.976,1.377,3.473,8.057,18.948,20.84,20.9,2.511.384,8.405.485,6.706-.77-15.724-11.608-22.434-18.616-21.885-36.506.342-11.117,17.328-23.119,27.414-25.276a17.177,17.177,0,0,1,13.956,3.252c8.477,6.959,8.116,35.737,17.055,41.752,3.676,2.475,1.227-14.941,3.817-12.117,5.11,5.572,1.833,14.1.914,17.355-4.357,15.416-8.92,4.016-13.17,17.18-4.594,14.212,35.7,23.781,37.068,26.955,2.385,5.52-31.685,31.713-22.333,36.256,11.87,5.768,21.227-1.744,26.745,4.7,3.085,3.6,1.416,7.412,6.988,18.61,1.819,3.656,2.734,5.483,3.534,5.418,3.81-.306,9.979-30.8,0-59.207-4.187-11.92-8.289-23.6-19.279-32.73-5.814-4.828-10.688-6.565-12.077-12.2-1.983-8.057,6.25-11.493,7.9-24.2,1.128-8.691,1.921-21.122-1.151-29.09-2.9-7.525-5.414-14.055-12-19.977C276.8,9.941,264.04.272,250.5,0c-6.231-.125-10.811,8.371-18.035,10.91h0Z",
    transform: "translate(956.7 294.161)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.524,211.909c-11.654-1.227-21.7,4.02-22.426,11.719s8.136,14.93,19.8,16.156a28.3,28.3,0,0,0,13.734-1.768l49.461,4.551,1.485-24.126-48.917-1.925a28.7,28.7,0,0,0-13.137-4.6Z",
    transform: "translate(934.812 311.786)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.273,114.07h0a22.975,22.975,0,0,1,25.694,18.017c8.681,41.279,24.261,129.21-.209,130.677-31.995,1.919-62.709-5.755-62.709-5.755l7.679-44.152,24.956-2.56-14.675-68.662a22.982,22.982,0,0,1,19.263-27.566Z",
    transform: "translate(1014.325 303.637)",
    fill: "#3f3d58"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(746.037 175.589) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.934,237.754,140.3,360.864a3.222,3.222,0,0,1-4.4-1.155L.439,127.952a3.222,3.222,0,0,1,1.155-4.4L212.232.439a3.222,3.222,0,0,1,4.4,1.155L352.088,233.351A3.222,3.222,0,0,1,350.934,237.754Z",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.934,237.754,140.3,360.864a3.222,3.222,0,0,1-4.4-1.155L.439,127.952a3.222,3.222,0,0,1,1.155-4.4L212.232.439a3.222,3.222,0,0,1,4.4,1.155L352.088,233.351A3.222,3.222,0,0,1,350.934,237.754ZM2.243,124.661a1.933,1.933,0,0,0-.693,2.642L137,359.06a1.933,1.933,0,0,0,2.642.693l210.638-123.11a1.933,1.933,0,0,0,.693-2.642L215.523,2.243a1.933,1.933,0,0,0-2.642-.693Z",
    transform: "translate(0.001 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.619,58.239,35.376,88.773a3.222,3.222,0,0,1-4.4-1.155L.439,35.376a3.222,3.222,0,0,1,1.155-4.4L53.836.439a3.222,3.222,0,0,1,4.4,1.155L88.773,53.836A3.222,3.222,0,0,1,87.619,58.239ZM2.243,32.085a1.933,1.933,0,0,0-.693,2.642L32.085,86.969a1.933,1.933,0,0,0,2.642.693L86.969,57.128a1.933,1.933,0,0,0,.693-2.642L57.128,2.243a1.933,1.933,0,0,0-2.642-.693Z",
    transform: "translate(50.024 89.501)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.134,57.64,34.892,88.174a2.9,2.9,0,0,1-3.963-1.039L.4,34.892a2.9,2.9,0,0,1,1.039-3.963L53.677.4A2.9,2.9,0,0,1,57.64,1.434L88.174,53.677a2.9,2.9,0,0,1-1.039,3.963Z",
    transform: "translate(39.239 105.263)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.756,5.4,4.359,100.9a2.9,2.9,0,1,1-2.923-5L164.833.4a2.9,2.9,0,1,1,2.923,5Z",
    transform: "translate(84.714 118.104)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,5.4,4.359,77.835a2.9,2.9,0,0,1-2.924-5L125.373.4a2.9,2.9,0,0,1,2.924,5Z",
    transform: "translate(94.781 158.396)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.609,5.4,4.359,47.626a2.9,2.9,0,0,1-2.923-5L73.686.4a2.9,2.9,0,0,1,2.923,5Z",
    transform: "translate(138.273 55.07)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.578,5.4,4.359,37.087a2.9,2.9,0,0,1-2.924-5L55.655.4a2.9,2.9,0,1,1,2.923,5Z",
    transform: "translate(148.343 82.838)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.756,5.4,4.359,100.9a2.9,2.9,0,0,1-2.923-5L164.833.4a2.9,2.9,0,0,1,2.923,5Z",
    transform: "translate(104.851 152.561)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,5.4,4.359,77.835a2.9,2.9,0,1,1-2.923-5L125.373.4a2.9,2.9,0,1,1,2.924,5Z",
    transform: "translate(114.921 192.853)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.756,5.4,4.359,100.9a2.9,2.9,0,1,1-2.923-5L164.833.4a2.9,2.9,0,0,1,2.923,5Z",
    transform: "translate(124.991 187.019)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.756,5.4,4.359,100.9a2.9,2.9,0,1,1-2.923-5L164.833.4a2.9,2.9,0,0,1,2.923,5Z",
    transform: "translate(135.062 204.248)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.807,43.376a63.111,63.111,0,0,0,6.109-8.544c1.61-2.718,3.19-5.624,3.545-8.811a8.7,8.7,0,0,0-2.606-7.438,6.124,6.124,0,0,0-7.185-.817A7.306,7.306,0,0,0,0,24.291,9.653,9.653,0,0,0,4.126,31.6c4.83,3.5,12.372,3.316,17.52.654,5.8-3,8.794-10.846,4.239-16.218-.948-1.117-2.524.131-2.287,1.337a6.5,6.5,0,0,0,12.871-1.591l-2.048,1.2a15.635,15.635,0,0,0,15.552-1.668,14.5,14.5,0,0,0,2.91-2.813c1-1.308,2.686-2.153,4.049-3.095l9.825-6.789c1.445-1,.071-3.378-1.386-2.372l-8.9,6.148C54.991,7.416,53.5,8.428,52.024,9.466c-1.054.742-1.7,1.939-2.66,2.82a12.877,12.877,0,0,1-13.6,2.3,1.39,1.39,0,0,0-2.048,1.2,3.76,3.76,0,1,1-7.468.885L23.966,18c2.939,3.465.982,8.78-2.4,11.105A15.588,15.588,0,0,1,7.914,30.544a8.053,8.053,0,0,1-4.741-4.35A4.8,4.8,0,0,1,4.263,20.7a3.443,3.443,0,0,1,4.787-.051,6.159,6.159,0,0,1,1.632,5.556c-.44,2.752-1.962,5.29-3.377,7.64a58.692,58.692,0,0,1-5.465,7.61c-1.133,1.341.822,3.273,1.967,1.918Z",
    transform: "translate(246.172 233.341)",
    fill: "#17B8A6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1003.112,766.833H562.033c-.695,0-1.258-.767-1.258-1.713s.563-1.713,1.258-1.713h441.079c.695,0,1.258.767,1.258,1.713s-.563,1.713-1.258,1.713Z",
    transform: "translate(416.318 208.858)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.38b7c2ca07401104a68392b2029f3382.svg";
export { ForwardRef as ReactComponent };